import { CATEGORY_TYPES, getCategoryTypeForTransactionKind, getTransactionKind } from "./transaction-types";
import { formatCategoryName, normalizeCategoryName } from "./utils";

export function getCategoryTypeForTransaction(transaction = {}) {
  const kind = getTransactionKind(transaction);
  return getCategoryTypeForTransactionKind(kind);
}

export function findCategoryById(categories = [], id, type = null) {
  if (!id) return null;
  return categories.find((category) => (
    category.id === id &&
    (!type || category.type === type)
  )) || null;
}

export function findUniqueCategoryByName(categories = [], name, type = CATEGORY_TYPES.EXPENSE) {
  const normalized = normalizeCategoryName(name);
  if (!normalized) return null;

  const matches = categories.filter((category) => (
    category.type === type &&
    normalizeCategoryName(category.name) === normalized
  ));

  return matches.length === 1 ? matches[0] : null;
}

export function findCategoryByIdOrName(categories = [], id, name, type = CATEGORY_TYPES.EXPENSE) {
  if (id) return findCategoryById(categories, id, type);
  return findUniqueCategoryByName(categories, name, type);
}

export function getTransactionCategory(transaction = {}, categories = []) {
  const type = getCategoryTypeForTransaction(transaction);
  return findCategoryByIdOrName(categories, transaction.category_id, transaction.category, type);
}

export function getTransactionCategoryName(transaction = {}, categories = []) {
  return getTransactionCategory(transaction, categories)?.name ||
    transaction.category ||
    "";
}

export function formatTransactionCategoryName(transaction = {}, categories = []) {
  return formatCategoryName(getTransactionCategoryName(transaction, categories));
}

export function buildCategoryIdBackfill(transactions = [], categories = []) {
  if (!categories.length) return transactions;

  return transactions.map((tx) => {
    if (tx.category_id) return tx;
    const category = getTransactionCategory(tx, categories);
    if (!category?.id) return tx;

    return {
      ...tx,
      category_id: category.id,
    };
  });
}
